import { runtimeEnv, type RuntimeEnv } from '../config/runtimeEnv';

// Example: "sportsbook.dev.neotechsolutions.org" -> ["dev", "neotechsolutions", "org"]
export const getHostnameSegments = (hostname = window.location.hostname) => {
  const segments = hostname.split('.');

  if (segments.length > 2) {
    segments.shift();
  }

  return segments;
};

// Example: service="api", domain="dev.neotechsolutions.org" -> "https://api.dev.neotechsolutions.org"
const buildServiceUrl = (service: string, hostname = window.location.hostname) => {
  const segments = getHostnameSegments(hostname);
  return `https://${service}.${segments.join('.')}`;
};

export const getClientId = (hostname = window.location.hostname) => getHostnameSegments(hostname).join('.');
export const getApiUrl = (apiEndpoint = '', hostname = window.location.hostname) =>
  `${buildServiceUrl('api', hostname)}${apiEndpoint && `/${apiEndpoint}`}`;
export const getAuthUrl = (hostname = window.location.hostname) => buildServiceUrl('auth', hostname);

export const getKeycloakUrl = (env: RuntimeEnv = runtimeEnv, hostname = window.location.hostname) =>
  env.keycloakUrl ?? getAuthUrl(hostname);
export const getKeycloakClientId = (env: RuntimeEnv = runtimeEnv, hostname = window.location.hostname) =>
  env.keycloakClientId ?? getClientId(hostname);
export const getBaseApiUrl = (env: RuntimeEnv = runtimeEnv, hostname = window.location.hostname) =>
  env.apiBaseUrl ?? getApiUrl('', hostname);
export const getMinioUrl = (env: RuntimeEnv = runtimeEnv, hostname = window.location.hostname) =>
  env.minioUrl ?? buildServiceUrl('minio-api', hostname);
